import { useEffect, useState } from "react";
import { Input } from "@/components/ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

export const COUNTRIES = [
  { dial: "+47", flag: "🇳🇴", name: "Norge" },
  { dial: "+46", flag: "🇸🇪", name: "Sverige" },
  { dial: "+45", flag: "🇩🇰", name: "Danmark" },
  { dial: "+358", flag: "🇫🇮", name: "Finland" },
  { dial: "+354", flag: "🇮🇸", name: "Island" },
  { dial: "+44", flag: "🇬🇧", name: "Storbritannia" },
  { dial: "+49", flag: "🇩🇪", name: "Tyskland" },
  { dial: "+31", flag: "🇳🇱", name: "Nederland" },
  { dial: "+48", flag: "🇵🇱", name: "Polen" },
  { dial: "+33", flag: "🇫🇷", name: "Frankrike" },
  { dial: "+34", flag: "🇪🇸", name: "Spania" },
  { dial: "+39", flag: "🇮🇹", name: "Italia" },
  { dial: "+1", flag: "🇺🇸", name: "USA/Canada" },
];

const DEFAULT_DIAL = "+47";

function parsePhone(value) {
  const v = (value || "").trim();
  if (!v) return { dial: DEFAULT_DIAL, number: "" };
  const match = [...COUNTRIES].sort((a, b) => b.dial.length - a.dial.length)
    .find((c) => v.startsWith(c.dial));
  if (match) return { dial: match.dial, number: v.slice(match.dial.length).trim() };
  return { dial: DEFAULT_DIAL, number: v.replace(/^\+/, "") };
}

export default function PhoneInput({ value, onChange, testid, placeholder = "Telefonnummer", className = "" }) {
  const [dial, setDial] = useState(() => parsePhone(value).dial);
  const [number, setNumber] = useState(() => parsePhone(value).number);

  useEffect(() => {
    const p = parsePhone(value);
    setDial(p.dial);
    setNumber(p.number);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value]);

  const emit = (d, n) => {
    const clean = (n || "").replace(/[^\d\s]/g, "").trim();
    onChange(clean ? `${d} ${clean}` : "");
  };

  return (
    <div className={`flex gap-2 ${className}`}>
      <Select value={dial} onValueChange={(v) => { setDial(v); emit(v, number); }}>
        <SelectTrigger data-testid={testid ? `${testid}-dial` : undefined} className="w-28 bg-secondary border-border shrink-0">
          <SelectValue />
        </SelectTrigger>
        <SelectContent className="bg-popover border-border max-h-72">
          {COUNTRIES.map((c) => (
            <SelectItem key={c.dial} value={c.dial}>
              <span className="mr-1">{c.flag}</span> {c.dial}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
      <Input
        data-testid={testid}
        inputMode="tel"
        value={number}
        placeholder={placeholder}
        onChange={(e) => { const n = e.target.value; setNumber(n); emit(dial, n); }}
        className="bg-secondary border-border flex-1"
      />
    </div>
  );
}
